import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=c7077af2&scoped=true&"
import script from "./FilesList.vue?vue&type=script&lang=js&"
export * from "./FilesList.vue?vue&type=script&lang=js&"
import style0 from "./FilesList.vue?vue&type=style&index=0&id=c7077af2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7077af2",
  null
  
)

export default component.exports